/**
 * SPA-side mirror of the backend write-through allow-list
 * (packages/db/src/spaEntities.ts). Kept in sync by hand — the SPA cannot import
 * the server package. Only these collections are PUT to /api/state; reference
 * data (studios/agents/artists), the derived customerIdsByPhone index, and
 * read-only display collections are never persisted from the client.
 */
export const PERSISTABLE_ENTITIES = [
  'customers',
  'bookings',
  'deposits',
  'topupPlans',
  'waivers',
  'pieces',
  'confirmationCalls',
  'salePayments',
  'payoutRecords',
  'futureSignals',
  'selfBookLinks',
  'noRebookFlags',
  'noDepositDeclineFlags',
  'overrideRequests',
  'reconResolutions',
  'sequenceState',
  'rebookFollowupTasks',
  'healingCheckTasks',
  'internalComms',
  'internalDmThreads',
  'nurtureTouches',
  'nurtureInbounds',
  'nurtureTemplates',
  'marketingCampaigns',
  'cashLedgers',
  'merchItems',
  'docketLines',
  'settlementLandings',
  'depositLandings',
  'settlementLumps',
  'dayPacks',
  'paybyExtensionRequests',
  'sweeperOutcomes',
] as const;

export type PersistableEntity = (typeof PERSISTABLE_ENTITIES)[number];
